import { JiraFromUI } from '@app/booking-frontend-libs';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { getConfirmedStatuses } from '../shared';
import { useFieldOptions } from '../../libs/useFieldOptions';
import { ConflictCheckBox } from './ConflictReportBox';
import { Spinner } from '@forge/react';
function reducer(state, action) {
    switch (action.type) {
        case 'error': {
            const a = action;
            return {
                error: a.error,
                working: false
            };
        }
        case 'conflict': {
            const a = action;
            return {
                working: false,
                conflictingIssues: a.issues
            };
        }
        case 'loading': {
            return {
                working: true
            };
        }
    }
    return state;
}
export function ConflictCheck(props) {
    var _a;
    const timeout = useRef(null);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [state, dispatch] = useReducer(reducer, {
        working: false
    });
    const { options } = useFieldOptions(props.configuration);
    const { working, error, conflictingIssues } = state;
    // biome-ignore lint/correctness/useExhaustiveDependencies: only react to the defined list of values
    useEffect(() => {
        async function requestValidation() {
            const params = {
                startDate: props.values.startDate,
                endDate: props.values.endDate,
                statusesIds: getConfirmedStatuses(props.configuration)
            };
            if (props.issueKey) {
                params.excludedWorkItemIds = [props.issueKey];
            }
            if (props.values.resource) {
                params.fieldValues = [props.values.resource];
            }
            const conflictingIssues = await JiraFromUI.fetchIssuesFromConfiguration(props.configuration, params);
            dispatch({ type: 'conflict', issues: conflictingIssues });
        }
        dispatch({ type: 'loading' });
        clearTimeout(timeout.current);
        if (props.values.resource && props.values.startDate && props.values.endDate) {
            if (!hasLoaded) {
                requestValidation();
                setHasLoaded(true);
            }
            else {
                timeout.current = setTimeout(() => requestValidation(), 1000);
            }
        }
        return () => {
            clearTimeout(timeout.current);
        };
    }, [props.values.resource, props.values.startDate, props.values.endDate]);
    const resourceLabel = (_a = options.find((o) => o.id === props.values.resource)) === null || _a === void 0 ? void 0 : _a.value;
    if (!hasLoaded) {
        return null;
    }
    if (hasLoaded && working) {
        return React.createElement(Spinner, null);
    }
    return (React.createElement(ConflictCheckBox, { selectedLabel: resourceLabel, hasConflict: (conflictingIssues === null || conflictingIssues === void 0 ? void 0 : conflictingIssues.length) > 0, conflictingIssues: conflictingIssues }));
}
